import { render, staticRenderFns } from "./JButton.vue?vue&type=template&id=0a41a6df&"
import script from "./JButton.vue?vue&type=script&lang=js&"
export * from "./JButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports